import React from 'react';

const ToastContext = React.createContext();

export default ToastContext;
